import _objectSpread from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { Actions } from './index.constants';
var currentDate = new Date();
export var initialState = {
  date: currentDate,
  selectedDate: currentDate
};
export var reducer = function reducer(state, action) {
  var date;

  switch (action.type) {
    case Actions.SELECT_YEAR:
      date = new Date(action.year, state.date.getMonth(), state.date.getDate());
      return _objectSpread(_objectSpread({}, state), {}, {
        date: date
      });

    case Actions.SELECT_MONTH:
      date = new Date(state.date.getFullYear(), action.month, state.date.getDate());
      return _objectSpread(_objectSpread({}, state), {}, {
        date: date
      });

    case Actions.SELECT_DAY:
      date = new Date(state.date.getFullYear(), state.date.getMonth(), action.day);
      return _objectSpread(_objectSpread({}, state), {}, {
        date: date,
        selectedDate: date
      });

    default:
      return state;
  }
};